function detectPlatform() {
  const w = window as any;
  const isNative = !!w?.Capacitor?.isNativePlatform?.();
  const platformName: string = w?.Capacitor?.getPlatform?.() ?? 'web';

  return {
    isNative,
    isAndroid: platformName === 'android',
    isIos: platformName === 'ios',
    isWeb: platformName === 'web',
  } as const;
}

export const platform = detectPlatform();
